
import React from 'react';

import Ledbulbhousing from './Ledbulbhousing';
import Bulbhousings from './Bulbhousings';
import Manufacturingmachine from './Manufacturingmachine';
import Machinefeartu from './Machinefeartu';

const Ledbulmachi = () => {
    return (
        <div>
            <Ledbulbhousing />
            <Bulbhousings />
            <Manufacturingmachine />
            <Machinefeartu />
        </div>
    );
};

export default Ledbulmachi;
